document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('#Search-In-Modal');
  const featuredContainer = document.querySelector('.featured-results');
  const predictiveSearch = document.querySelector('.predictive-search--header');

  searchInput.addEventListener('input', () => {
    const query = searchInput.value.trim();

    if (query.length > 0) {
      featuredContainer.style.display = 'none';
      predictiveSearch.style.display = 'block';
    } else {
      featuredContainer.style.display = 'block';
      predictiveSearch.style.display = 'none';
    }
  });

 
});